import {
  AfterViewInit,
  Directive,
  ElementRef,
  forwardRef,
  HostListener,
  Input,
} from '@angular/core';
import { NumberFormatMask } from '@macs-frontend/web-macs/shared/models/number-format-mask';
import { Store } from '@ngrx/store';
import * as accounting from 'accounting-js';
import { FormViewAdapter, NGRX_FORM_VIEW_ADAPTER } from 'ngrx-forms';
import { Subscription } from 'rxjs';
import { getCurrentCompanyNumberMask } from '../../../reducers/meta';

// eslint-disable-next-line functional/no-let
let maskSubscription: Subscription | undefined;
// eslint-disable-next-line functional/no-let
let maskValue: NumberFormatMask | undefined;

/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @angular-eslint/directive-class-suffix */
@Directive({
  selector: '[contenteditable][ngrxFormControlState]',
  providers: [
    {
      provide: NGRX_FORM_VIEW_ADAPTER,
      useExisting: forwardRef(() => EditableViewAdapterDirective),
      multi: true,
    },
  ],
})
export class EditableViewAdapterDirective implements FormViewAdapter, AfterViewInit {
  private value: any;

  companyNumberMask$ = this.store$.select(getCurrentCompanyNumberMask);

  @Input()
  isNumber = false;

  @Input()
  numberPrecision = 2;

  @HostListener('input', ['$event'])
  onInput(e: { target: { innerText: any } }) {
    this.value = e.target.innerText;
    this.onChangeCallback(this.isNumber ? this.parseNumber(this.value) : this.value);
  }

  @HostListener('blur', ['$event'])
  onBlur(e: any) {
    if (this.isNumber) {
      this.setViewValue(this.parseNumber(this.value));
    }
  }

  onChangeCallback = (_: any) => {};

  constructor(private elementRef: ElementRef, readonly store$: Store<any>) {}

  setViewValue(value: any) {
    this.value = this.isNumber ? this.formatNumber(value) : value;
    this.elementRef.nativeElement.innerText = this.value;
  }

  formatNumber(n: number | null): string {
    if (n === null) {
      return '';
    }
    return accounting.formatMoney(n, {
      format: '%v',
      precision: this.numberPrecision,
      thousand: this.getThousandsSeparator(),
      decimal: this.getRadix(),
    });
  }

  private getRadix() {
    return maskValue ? maskValue.radix : '.';
  }

  private getThousandsSeparator() {
    return maskValue ? maskValue.thousandsSeparator : ' ';
  }

  parseNumber(str: string) {
    // eslint-disable-next-line no-param-reassign
    str = str
      .replace(this.getThousandsSeparator(), '')
      .replace(this.getRadix(), '.')
      .replace(/[^0-9\.]/g, '');

    if (str === '') {
      return null;
    }

    const number: number =
      this.numberPrecision === 0 ? parseInt(str, 10) : parseFloat(str);

    return isNaN(number) ? 0 : number;
  }

  setOnChangeCallback(fn: any) {
    this.onChangeCallback = fn;
  }

  setOnTouchedCallback(fn: any) {}

  setIsDisabled(isDisabled: boolean) {}

  ngAfterViewInit(): void {
    if (!maskSubscription) {
      maskSubscription = this.companyNumberMask$.subscribe(mask => (maskValue = mask));
    }
  }
}
